import { HStack, Modal, ModalBody, ModalContent, ModalOverlay, Spinner, Text } from "@chakra-ui/react";

import { $string } from "foundation-ts/commons";

import { WaitingModalProps } from "@components/Modals/ModalConstants";
import { $g1Color } from "@/theme/G1Style";

export const WaitingModal = (props: WaitingModalProps) => {
    const { isOpen, onClose, message } = props ;
    return (
        <Modal onClose={onClose} size="xs" isOpen={isOpen} closeOnEsc={false} isCentered={true}>
            <ModalOverlay backdropFilter="blur(6px)" />
            <ModalContent>
                <ModalBody>
                    <HStack>
                        <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor={$g1Color('spinner.bg')}
                            color={$g1Color('spinner.write')}
                            size='lg'
                        />
                        <Text>{$string(message)}</Text>
                    </HStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    ) ;
}